import { GOOGLE_MAPS_API_KEY } from "../../../../../shared/consts";

type Location = {
  lat: number;
  lng: number;
};

type TimezoneResponse = {
  timeZoneId?: string;
  status?: string;
  errorMessage?: string;
};

export async function getAddressTimezone(location: Location): Promise<string> {
  const params = new URLSearchParams({
    location: `${location.lat},${location.lng}`,
    timestamp: Math.floor(Date.now() / 1000).toString(),
    key: GOOGLE_MAPS_API_KEY,
  });

  const response = await fetch(`https://maps.googleapis.com/maps/api/timezone/json?${params}`);
  const timezoneResponse = (await response.json()) as TimezoneResponse;

  if (!response.ok || timezoneResponse.timeZoneId === undefined) {
    throw new Error(timezoneResponse.errorMessage ?? "Could not get timezone from location");
  }

  return timezoneResponse.timeZoneId;
}
